/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

import template from './views/create-club.html';
import controller from './controllers/createclubController';
var module = angular.module('createClub', [
    //import modules
]).controller('createClub', controller);

module.constant('createClub', {
})
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('createClub', {
//             parent: 'app',
//             url: '/create-club',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'createClub'
//                 }
//             },
//             params: {
//                 "user_privilege": null,
//                 "club_id": null,
//                 "mode": null
//             }
//         })

// });


// WEBPACK FOOTER //
// ./src/app/club_activity/createclubModule.js